import { Anchor } from "@mantine/core";
import type { DataTableColumn } from "mantine-datatable";
import { getFullName, getYearString } from "../../helpers/stringHelper";
import { occupationTranslations } from "../../models/enums/occupation";
import type { Group } from "../../models/group";
import { DataTable, type DataTableProps } from "../datatable/DataTable";

type GroupTableProps = Required<
  Pick<
    DataTableProps<Group>,
    "sortStatus" | "onSortStatusChange" | "onEdit" | "onDelete" | "onView" | "pagination" | "onPageChange" | "fetching"
  >
> & {
  groups: Group[];
};

export function GroupTable({ groups, onView, ...props }: GroupTableProps) {
  const columns: DataTableColumn<Group>[] = [
    {
      accessor: "name",
      title: "Gruppenname",
      sortable: true,
      render: (group) => <Anchor onClick={() => onView(group)}>{group.name}</Anchor>,
    },
    {
      accessor: "responsible_coach",
      title: "Verantwortlicher Coach",
      sortable: true,
      render: (group) => getFullName(group.coach),
    },
    {
      accessor: "year_context",
      title: "Jahrgang",
      sortable: true,
      sortKey: "year_context",
      render: (group) => getYearString(group.year_context),
    },
    {
      accessor: "occupation",
      title: "Beruf",
      sortable: true,
      render: (group) => occupationTranslations[group.occupation],
    },
  ];

  return <DataTable<Group> records={groups} columns={columns} onView={onView} {...props} />;
}
